/*
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2022-01-29 13:43:53
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import Layout from '@/views/layout'
// import personalDetailIndex from '@/views/personalDetail/index'

import passportRouter from './modules/passwordRouter'
import settleRouter from './modules/settleRouter'
import personalRouter from './modules/personalRouter'
import mallRouter from './modules/mallRouter'

import store from "@/store/index"
import { isEmptyOrNull } from "../utils/index"
import { checkIsLogin } from '@/api/passport/passportApi'
import { loginOut } from '@/utils/auth'
Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 }
  },
  routes: passportRouter.concat(settleRouter).concat(personalRouter).concat(mallRouter).concat([
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/signLine',
          component: () => import('@/views/signLine'),
          name: 'signLine',
          meta: { title: '生科供应链-生物科研用品数字供应链', icon: '', affix: true }
        },
        {
          path: '/',
          component: () => import('@/views/home'),
          name: 'home',
          meta: { title: '生科供应链-生物科研用品数字供应链', icon: '', affix: true }
        },
        {
          path: '/productDetail',
          component: () => import('@/views/productList/detail'),
          name: 'productDetail',
          meta: { title: '商品详情', icon: '', affix: true }
        },
        {
          path: '/productList',
          component: () => import('@/views/productList/productList'),
          name: 'productList',
          meta: { title: '产品列表', icon: '', affix: true }
        },
        {
          path: '/brandMuseum',
          component: () => import('@/views/brandMuseum/brandMuseum'),
          name: 'brandMuseum',
          meta: { title: '品牌集结', icon: '', affix: true }
        },
        {
          path: '/newProduct',
          component: () => import('@/views/activity/newProduct'),
          name: 'newProduct',
          meta: { title: '产品上新', icon: '', affix: true }
        },
        {
          path: '/specialOffer',
          component: () => import('@/views/activity/specialOffer'),
          name: 'specialOffer',
          meta: { title: '热销推荐', icon: '', affix: true }
        },
        {
          path: '/sample',
          component: () => import('@/views/activity/sample'),
          name: 'sample',
          meta: { title: '样品申请', icon: '', affix: true }
        }
      ]
    },
    {
      path: '/payReturn',
      component: () => import('@/views/settle/payment'),
      name: 'payment',
      meta: { title: '支付成功', icon: '', affix: true }
    },
    {
      path: '/payOrder',
      component: () => import('@/views/settle/payOrder'),
      name: 'payOrder',
      meta: { title: '支付页面', icon: '', affix: true }
    },
    {
      path: '/wxApply',
      component: () => import('@/views/settle/wxapply'),
      name: 'wxapply',
      meta: { title: '微信支付页面', icon: '', affix: true }
    },
  ])
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach(async (to, from, next) => {
  // 设置标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.query.from) {
    Cookies.set('sellerId', to.query.from);
  }


  let newTime = new Date().getTime();
  const requireAuth = to.meta.requireAuth
  const lastLoginCheckTime = store.getters.getLastLoginCheckTime;
  if (lastLoginCheckTime == null || newTime - lastLoginCheckTime >= 900000) {
    store.commit("$_setLastLoginCheckTime", newTime);
    let isLogin = true;
    await checkIsLogin().then(res => {
      if (res.success && !res.data) {
        isLogin = false;
      }
    })

    if (!isLogin) {
      loginOut();
      if (requireAuth) {
        next('/passport/login');
        return;
      }
    }
  }

  if (!requireAuth) {
    next()
  } else {
    const token = store.getters.getToken
    if (!isEmptyOrNull(token)) {
      next()
    } else {
      next('/passport/login')
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js